'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactRedux = require('react-redux');

var _actionCreators = require('../../../store/actions/action-creators');

function mapStateToProps() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var ownProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var feedUserId = ownProps.feedUserId;

  var feedUserKey = feedUserId && feedUserId.type + '-' + feedUserId.relatedId;

  var isFollowing = void 0;
  if (state.follow && feedUserKey) {
    isFollowing = state.follow.userFollows && state.follow.userFollows[feedUserKey];
  }

  return {
    isFollowing: isFollowing
  };
}

var mapDispatchToProps = {
  getIsFollowing: _actionCreators.getIsFollowing,
  followUser: _actionCreators.followUser,
  unfollowUser: _actionCreators.unfollowUser
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps);